import { useGlobalAPIQueryContext } from "@dev2_techwalnut/tw-api-query-hook";
import { useAPIQuery } from "../../../hooks/useAPIQuery";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";

const DispatchUpdate = () => {
    const userID = secureLocalStorage.getItem("userID");
    const navigate = useNavigate();
    const location = useLocation();
    const dispatchedSO = location.state?.editpost;

    console.log(dispatchedSO);

    const { invalidateApi } = useGlobalAPIQueryContext();

    const dispatchQuery = useAPIQuery({
        key: "dispatch",
        endpoint: "/api/dispatch/",
    });

    const dispatch = dispatchQuery.useCreate({
        successMessageFromServer: true,
        errorMessageFromServer: true,
        onSuccess: () => {
            setTimeout(() => {
                invalidateApi({ key: "api/sales-order" });
                navigate(-1);
            }, 1000);
        },
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({ mode: "onBlur" });

    const onSubmit = (data) => {
        console.log(data);

        const res = {
            sales_order_id: dispatchedSO?.id,
            dispatch_amount: data.dispatch_amount,
            dispatch_date: data.dispatch_date,
            invoice_number: data.invoice_number,
            dispatch_number: data.dispatch_number,
            created_by: userID,
            updated_by: userID,
        };

        console.log(res);

        dispatch.mutate({
            data: res,
        });
    };

    useEffect(() => {
        if (dispatchedSO) {
            reset({
                dispatch_amount:
                    dispatchedSO?.product_details
                        ?.quantity_available_for_sales_order,
                dispatch_date: moment(dispatchedSO?.dispatch_date).format(
                    "YYYY-MM-DD"
                ),
            });
        }
    }, [dispatchedSO]);

    return (
        <div className="card">
            <div className="card-inner">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h4 className="nk-block-title">
                                Dispatch Sales Order
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div class="card">
                        <div class="card-inner">
                            <form
                                onSubmit={handleSubmit(onSubmit)}
                                autoComplete="off"
                            >
                                <div className="row g-4">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">
                                            Dispatched Quantity
                                            <span className="fs-8 text-danger">
                                                {" "}
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            {...register("dispatch_amount", {
                                                required:
                                                    "Dispatched quantity is required.",
                                                min: {
                                                    value: 1,
                                                    message:
                                                        "Cannot be less than 1",
                                                },
                                                max: {
                                                    value:
                                                        dispatchedSO
                                                            ?.product_details
                                                            ?.quantity_available_for_sales_order ??
                                                        0,
                                                    message: `Cannot exceed ${
                                                        dispatchedSO
                                                            ?.product_details
                                                            ?.quantity_available_for_sales_order ??
                                                        0
                                                    }`,
                                                },
                                            })}
                                            placeholder="Enter dispatched quantity"
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        {errors.dispatch_amount && (
                                            <span className="fs-8 text-danger">
                                                {
                                                    errors.dispatch_amount
                                                        ?.message
                                                }
                                            </span>
                                        )}
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">
                                            Dispatch Date
                                            <span className="fs-8 text-danger">
                                                {" "}
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register("dispatch_date", {
                                                required:
                                                    "Dispatch date is required.",
                                            })}
                                        />
                                        {errors.dispatch_date && (
                                            <span className="fs-8 text-danger">
                                                {errors.dispatch_date?.message}
                                            </span>
                                        )}
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">
                                            Invoice Number
                                            <span className="fs-8 text-danger">
                                                {" "}
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("invoice_number", {
                                                required:
                                                    "Invoice number is required.",
                                            })}
                                            placeholder="Enter invoice number"
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        {errors.invoice_number && (
                                            <span className="fs-8 text-danger">
                                                {errors.invoice_number?.message}
                                            </span>
                                        )}
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">
                                            Dispatch Number
                                            {/* <span className="fs-8 text-danger">
                                                {" "}
                                                *
                                            </span> */}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register("dispatch_number", {
                                                // required:
                                                //     "Invoice number is required.",
                                            })}
                                            placeholder="Enter dispatch number"
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        {errors.dispatch_number && (
                                            <span className="fs-8 text-danger">
                                                {
                                                    errors.dispatch_number
                                                        ?.message
                                                }
                                            </span>
                                        )}
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group">
                                            <button
                                                type="button"
                                                className="btn btn-md btn-light me-2"
                                                id="submit-button-backbutton"
                                                onClick={() => navigate(-1)}
                                            >
                                                Back
                                            </button>
                                            {dispatch.isPending ? (
                                                <button
                                                    type="button"
                                                    id="button-dispatch-loading"
                                                    className="btn btn-md text-dark"
                                                    disabled
                                                >
                                                    Loading...
                                                </button>
                                            ) : (
                                                <button
                                                    type="submit"
                                                    className="btn btn-md btn-primary"
                                                    id="submit-button-create-dispatch"
                                                >
                                                    Dispatch
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DispatchUpdate;
